import clsx from 'clsx';

import { ColorDisplayOption } from '@vestico/model';

import { CommonColorSelectOption } from './CommonColorSelectOption';
import style from './SingleColorSelectOption.module.css';

export interface SingleColorSelectOptionProps {
  option: ColorDisplayOption;
  selected?: boolean;
  didUpdateConfig: () => void;
  hideTitle?: boolean;
}

export const SingleColorSelectOption = ({ option, selected, didUpdateConfig, hideTitle }: SingleColorSelectOptionProps) => {
  const { title, hexColor } = option;
  return (
    <CommonColorSelectOption title={title} hexColor={hexColor} selected={selected} didUpdateConfig={didUpdateConfig} hideTitle={hideTitle}>
      <div className={clsx(style.colorBlock)} />
    </CommonColorSelectOption>
  );
};
